import React, { createContext, useContext, useState, useEffect } from 'react';

const ServiceContext = createContext();

const DEFAULTS = [
  'Web Development','Mobile App','CRM Development','UI/UX Design',
  'Digital Marketing','SEO','Social Media Management','AI Automation',
  'E-commerce','Software Development','Consulting','Other'
];

// Services are per-company. On first load we seed from the services the
// company entered during onboarding (so Tools > Service Types shows exactly
// their services, nothing else). If none were entered, we fall back to a
// generic starter list. Edits here persist and stay in sync everywhere.
function loadInitial() {
  try {
    const saved = JSON.parse(localStorage.getItem('ryzenos_services') || 'null');
    if (Array.isArray(saved) && saved.length) return saved;
  } catch {}
  try {
    const onboarding = JSON.parse(localStorage.getItem('ryzenos_company_profile') || localStorage.getItem('ryzenos_company') || 'null');
    if (onboarding && Array.isArray(onboarding.services) && onboarding.services.length) return onboarding.services;
  } catch {}
  return DEFAULTS;
}

export function ServiceProvider({ children }) {
  const [services, setServices] = useState(loadInitial);

  useEffect(() => {
    localStorage.setItem('ryzenos_services', JSON.stringify(services));
  }, [services]);

  const add    = (s) => { if(s.trim() && !services.includes(s.trim())) setServices(p=>[...p,s.trim()]); };
  const remove = (s) => setServices(p=>p.filter(x=>x!==s));
  const edit   = (old,nw) => { if(nw.trim()) setServices(p=>p.map(x=>x===old?nw.trim():x)); };
  return <ServiceContext.Provider value={{services,add,remove,edit}}>{children}</ServiceContext.Provider>;
}

export const useServices = () => useContext(ServiceContext);
